/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme-dark/base/colors";
import borders from "assets/theme-dark/base/borders";
import typography from "assets/theme-dark/base/typography";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";
import rgba from "assets/theme-dark/functions/rgba";

const { transparent, white, inputBorderColor, info, background, text } = colors;
const { borderRadius } = borders;
const { size, fontWeightRegular, fontWeightMedium } = typography;

const select = {
  styleOverrides: {
    root: {
      minHeight: pxToRem(48),
      color: white.main,
      background: `linear-gradient(180deg, ${rgba(background.card, 0.9)} 0%, ${rgba(
        background.sidenav,
        0.94
      )} 100%)`,
      borderRadius: borderRadius.md,

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: rgba(inputBorderColor, 0.65),
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: rgba(inputBorderColor, 0.75),
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: info.main,
      },
    },

    select: {
      display: "flex",
      alignItems: "center",
      minHeight: `${pxToRem(48)} !important`,
      padding: `${pxToRem(12)} ${pxToRem(40)} ${pxToRem(12)} ${pxToRem(14)} !important`,
      color: `${white.main} !important`,
      WebkitTextFillColor: white.main,
      fontSize: size.sm,
      fontWeight: fontWeightRegular,
      lineHeight: 1.4,
      boxSizing: "border-box",

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      minHeight: pxToRem(48),
      color: `${white.main} !important`,
      display: "flex",
      alignItems: "center",
    },

    icon: {
      color: rgba(white.main, 0.82),
      display: "block",
      right: pxToRem(12),
      fontSize: pxToRem(20),
    },

    outlined: {
      borderRadius: borderRadius.md,
    },

    standard: {
      minHeight: pxToRem(48),
    },

    filled: {
      minHeight: pxToRem(48),
    },

    multiple: {
      minHeight: `${pxToRem(48)} !important`,
      paddingTop: `${pxToRem(10)} !important`,
      paddingBottom: `${pxToRem(10)} !important`,
    },

    nativeInput: {
      color: `${white.main} !important`,
      WebkitTextFillColor: white.main,
      fontWeight: fontWeightMedium,
    },

    disabled: {
      color: rgba(text.main, 0.48),
    },
  },
};

export default select;
